import Vue from 'vue'
import axios from 'axios'

const state = Vue.observable({
  online: navigator.onLine,
  serverReachable: true,
  lastCheckTime: null,
})

let heartbeatTimer = null
const HEARTBEAT_INTERVAL = 15 * 1000

const heartbeatClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10000,
})

window.addEventListener('online', () => {
  state.online = true
  checkServerNow()
})

window.addEventListener('offline', () => {
  state.online = false
  state.serverReachable = false
})

async function checkServerNow() {
  if (!state.online) {
    state.serverReachable = false
    return
  }
  try {
    await heartbeatClient.get('/')
    state.serverReachable = true
  } catch (e) {
    if (e.response) {
      state.serverReachable = true
    } else {
      state.serverReachable = false
    }
  }
  state.lastCheckTime = Date.now()
}

export function startHeartbeat() {
  stopHeartbeat()
  checkServerNow()
  heartbeatTimer = setInterval(checkServerNow, HEARTBEAT_INTERVAL)
}

export function stopHeartbeat() {
  if (heartbeatTimer) {
    clearInterval(heartbeatTimer)
    heartbeatTimer = null
  }
}

export function markDisconnected() {
  state.serverReachable = false
}

export function markConnected() {
  state.serverReachable = true
}

export function checkNow() {
  return checkServerNow()
}

export default state
